/**
 * Real Estate client type overrides for English (US)
 *
 * These overrides are intentionally minimal. Properties now have their own
 * dedicated navigation item and labels, so we no longer override product
 * translations for real-estate tenants.
 */
export const realEstateEnUsOverrides = {
  'sidebar.catalog': 'Portfolio',
};
